import { render, staticRenderFns } from "./SysBasic.vue?vue&type=template&id=46c42d60&scoped=true"
import script from "./SysBasic.vue?vue&type=script&lang=js"
export * from "./SysBasic.vue?vue&type=script&lang=js"


/* normalize component */
import normalizer from "!../../../node_modules/vue-loader/lib/runtime/componentNormalizer.js"
var component = normalizer(
  script,
  render,
  staticRenderFns,
  false,
  null,
  "46c42d60",
  null
  
)

export default component.exports